import { ItemNFProps } from '../../protocols/ItemNFProps';

export const verificarDescontosNegativos = (itens: ItemNFProps[]): boolean => {
  return itens.some(
    (item) => item.val_desconto !== null && item.val_desconto < 0,
  );
};
